import { Fragment } from "react";
import { isAudio } from 'helpers/AppHelper';
import * as ConfigTypes from 'config/ConfigTypes';
import { subBefore, subAfter } from 'helpers/TypeHelper';

export const checkAndRemoveMixes = ({ strValue }) => {
    if (strValue.startsWith("[")) strValue = subAfter(strValue, "[");
    if (strValue.endsWith("]")) strValue = subBefore(strValue, "]");
    return strValue;
}

export const parseArray = ({ newValue, filterType }) => {
    try {
        let oneEl = newValue[0];
        if (typeof oneEl === 'object') {
            if (filterType) {
                if (filterType == "mw null") {
                    newValue = newValue.map(item => item.name).join(" - ");
                } else {
                    newValue = newValue.filter(item => item.type === filterType)
                        .map(item => item.name).join(" - ");
                }
                if (!newValue) newValue = "";
            }
            else {
                newValue = newValue.map(nv => {
                    if (nv && nv.name) return nv.name;
                    return "";
                });
            }
        } else if (typeof oneEl === 'string') {
            newValue = newValue.join(" -  ");
        }

    } catch (e) { newValue = ""; }
    return newValue;
}

export const parseObject = ({ newValue, filterType }) => {
    try {
        if (filterType) {
            let filterValue = newValue[`${filterType}`];
            if (typeof filterValue == 'object' && filterValue.length) {
                newValue = filterValue.join(",");
            }
        }
        if (typeof newValue == "string") return newValue;
        //if (typeof newValue == "string") return checkAndRemoveMixes({ strValue: newValue });
        return "";
    } catch (e) { newValue = ""; }
    return newValue;
}

export const parseStringField = (fieldValue, filterType = false) => {
    if (!fieldValue) fieldValue = "";
    let newValue = "";
    try {
        newValue = JSON.parse(fieldValue);
    } catch (err) { fieldValue = fieldValue; }

    if (typeof newValue === 'string') {
        //return checkAndRemoveMixes({ strValue: newValue });
        return fieldValue;
    }
    if (typeof newValue === 'object') {
        if (newValue.length) newValue = parseArray({ newValue, filterType });
        else newValue = parseObject({ newValue, filterType })
    }
    return newValue;
}

export const sliceText = (txt, len) => {
    if (txt && typeof txt === 'string' && txt.length > len) {
        return txt.slice(0, len);
    }
    return txt;
}


export const checkGroupFields = ({ el, isGroup, viewMode, element }) => {
    if (isGroup) {
        if (el[`${viewMode}group`].dategroup) {
            return showDateGroup({ isGroup, el, element, viewMode, txtClass: "", dategroup: el[`${viewMode}group`].dategroup })
        }
        let connect = el[`${viewMode}group`].connect || "";
        let space = <span>&nbsp;</span>
        if (isGroup) {
            let withField = element.metadata.fields[el[`${viewMode}group`].with] || '';
            withField = checkAndRemoveMixes({ strValue: withField });
            if (withField) {
                return (
                    <Fragment>
                        {(element.metadata.fields[el.field] && !connect) && space}
                        {connect}
                        {withField}
                    </Fragment>
                )
            }
        }
    }
}

export const getSearchFields = (current, sort) => {
    let fields = [];
    if (current && current.field) {
        fields = [{ 'field': current.field, 'type': 'ORDER', 'value': sort }];
    }

    return fields;
}

export const getSortField = (current, sort) => {
    let field;
    if (current && current.field) {
        field = { 'field': current.field, 'type': 'ORDER', 'value': sort }
    }

    return field;
}

export const EmailBox = ({ el, htmlClasses = "mainpage-contact" }) => {
    return (
        <div className={htmlClasses}>
            <a href={`mailto:${el.value}?subject=Feedback&body=Message`}>
                {el.value}
            </a>
        </div>)
}

export const LinkBox = ({ el, intl, htmlClasses = "mainpage-contact" }) => {
    return (
        <div className={htmlClasses}>
            <a href={el.link}>
                {el.type === "button" ? <div>{intl}</div> : intl}
            </a>
        </div>)
}

export const PhoneBox = ({ el, htmlClasses = "mainpage-contact" }) => {
    return (<div className={htmlClasses}>
        <figure>
            <figcaption>
                <a href={`tel:+${el.value}`}>
                    {el.value}
                </a>
            </figcaption>
        </figure>

    </div>)
}

export const showDateGroup = ({ el, element, viewMode, txtClass, dategroup = ConfigTypes.ALL }) => {
    let matched = false;
    let withField = element.metadata.fields[el[`${viewMode}group`].with] || '';
    let field = parseStringField(element.metadata.fields[el.field]);
    if (dategroup !== ConfigTypes.ALL) {
        withField = sliceText(withField, +dategroup);
        field = sliceText(field, +dategroup);
    }
    if (field == withField) matched = true;
    return (
        <div className={txtClass}>
            {field}&nbsp;
            {(withField && !matched && field) && el[`${viewMode}group`].connect}&nbsp;
            {!matched && withField}
        </div>)
}


export const getMediaFileDuration = (elements, clip, type) => {
    let duration = "00:00:00:00";
    if (clip && elements && elements.length) {
        let pattern = /.mp4$/i;
        let isType = (clip && clip.media && clip.media.fields && clip.media.fields[type]) ? true : false;
        if (isAudio()) pattern = /.mp3$|.mp4$|.wav$|.aac$/i;
        let obj = elements.find(item => (isType && item.data.tags && item.data.tags.includes("preview")));
        if (!obj || !obj.duration || obj.duration === '00:00:00:00') {
            obj = elements.find(item => (item.data.url.search(pattern) > -1 && item.data.tags && item.data.tags.includes("preview")));
        }
        if (!obj || !obj.duration || obj.duration === '00:00:00:00') {
            obj = elements.find(item => (item.data.url.search(pattern) > -1 && item.data.sourcefile));
        }
        if (!obj || !obj.duration || obj.duration === '00:00:00:00') {
            obj = elements.find(item => (item.data.url.search(pattern) > -1));
        }
        if (obj && obj.duration) {
            duration = obj.duration;
        }
    }
    return duration;
}

export const getDuration = (props) => {
    let duration = '00:00:00:00';
    let elements;
    if (props && props.clip.mediafiles && props.clip.mediafiles.elements) {
        elements = props.clip.mediafiles.elements
    }
    duration = getMediaFileDuration(elements, props.clip, ConfigTypes.AUDIO);
    if (duration.length == 4) {
        duration = duration[0] + ":" + duration[1] + ":" + duration[2] + ":" + duration[3];
    }
    return duration;
}


export const ElementWrapper = ({ el, viewMode, children }) => {
    const lineSpace = <div>&nbsp;</div>;
    return (
        <Fragment>
            {el[`${viewMode}verSpace`] && lineSpace}
            {children}
            {el[`${viewMode}verSpace`] && lineSpace}
        </Fragment>)
}

export const checkMapping = ({ el, fieldTxt, term, replaceTerm = ConfigTypes.CHECK_TERM }) => {
    let found = false;
    let newFields = [];
    let defTerm;
    if (el.optionAsMapp && el.options && el.options.length) {
        el.options.forEach(option => {
            let curOpt = option.split("=");
            if (term) {
                defTerm = term;
                if (!fieldTxt.includes(term)) defTerm = ConfigTypes.CHECK_TERM;
                fieldTxt.split(defTerm).forEach(tmp => {
                    if (curOpt[0] == tmp.trim()) {
                        newFields.push(curOpt[1]);
                    }
                })
            } else {
                if (curOpt[0] == fieldTxt && !found) {
                    fieldTxt = curOpt[1];
                    found = true;
                }
            }
        });
        if (term && newFields && newFields.length) {
            fieldTxt = newFields.join(replaceTerm);
        }
    }
    return fieldTxt;
}

export const parseJsonData = (fValue) => {
    let newValue = "";
    if (!fValue) fValue = "";
    try {
        newValue = JSON.parse(fValue);
    } catch (err) { newValue = fValue; }
    return newValue;
}

export const parseExtraField = ({ fieldValue, extra }) => {
    let newValue = parseJsonData(fieldValue);
    if (typeof newValue == 'string' && extra.indexOf('longTxt') > -1) {
        return <pre>{newValue}</pre>
    }
    if (typeof newValue === 'object') {
        if (typeof newValue[0] === 'string') return <pre>{newValue[0]}</pre>
        if (typeof newValue[0] === 'object') {
            return newValue.map(nv => {
                return (
                    <>
                        {extra.map(entry => <pre>{nv[entry]}</pre>)}
                    </>)
            });
        }
    }
}

export const showOnlyType = ({ newValue, langetype, txtClass }) => {
    let tmp = [];
    newValue = newValue.reduce((acc, cur) => {
        if (acc.indexOf(cur.t) == -1) acc.push(cur.t);
        return acc;
    }, []);
    newValue.forEach(nv => {
        langetype.forEach(entry => {
            if (nv === entry.split("=")[0]) tmp.push(entry.split("=")[1])
        });
    })
    if (tmp) tmp = tmp.join(", ");
    return (<div className={txtClass}>{tmp}</div>)
}

export const showMappingLangType = ({ el, viewMode, fValue, txtClass, onlyType = false }) => {
    let langetype = el[`${viewMode}languagetype`];
    let newValue = parseJsonData(fValue);
    if (typeof newValue === 'object') {
        if (typeof newValue[0] === 'string') return newValue[0];
        if (typeof newValue[0] === 'object') {
            if (onlyType) return showOnlyType({ newValue, langetype, txtClass });
            return <div className={txtClass}>
                {
                    newValue.map(nv => {
                        let txt = "";
                        langetype.forEach(entry => {
                            if (nv.t === entry.split("=")[0] && !txt) txt = entry.split("=")[1];
                        });
                        if (nv.l) {
                            if (txt) txt = `${txt}: ${nv.l}`;
                            else txt = `${nv.l}`;
                        }
                        if (nv.o) txt = `${txt} (optional)`;
                        return (
                            <div>{txt}</div>)
                    })
                }
            </div>
        }
    }
}


export const showMappingUnitType = ({ el, viewMode, fValue, txtClass, betweenStr = " / " }) => {
    let unittype = el[`${viewMode}unittype`];
    let newValue = parseJsonData(fValue);
    if (typeof newValue === 'object') {
        if (typeof newValue[0] === 'string') return newValue[0];
        if (typeof newValue[0] === 'object') {
            let txt = "";
            newValue.forEach((nv, index) => {
                unittype.forEach(entry => {
                    if (nv[entry]) txt += nv[entry] + " ";
                });
                if (index !== (newValue.length - 1) && txt) txt += betweenStr;
            })
            return <div className={txtClass}>{txt}</div>
        }
    }
}


export const checkOtherConfig = ({ el, fieldTxt, viewMode }) => {
    if (fieldTxt) {
        if (el[`${viewMode}datetype`]) {
            fieldTxt = sliceText(fieldTxt, +el[`${viewMode}datetype`]);
        }
        if (el[`${viewMode}noLabelList`] && fieldTxt.includes(ConfigTypes.CHECK_TERM)) {
            fieldTxt = <div>{fieldTxt.split(ConfigTypes.CHECK_TERM).map(txt => <div>{txt}</div>)}</div>
        }
    }
    return fieldTxt;
}

export const showOptionAsMapp = ({ fieldTxt, txtClass }) => {
    if (fieldTxt.includes(ConfigTypes.CHECK_TERM)) {
        let dFields = fieldTxt.split(ConfigTypes.CHECK_TERM);
        return (
            <div className={txtClass}>
                {dFields && dFields.map(df => <div>{df}</div>)}
            </div>
        )
    }
    return (<div className={txtClass}>{fieldTxt}</div>)
}

export const getElementValue = ({ isGroup, el, element, viewMode, txtClass, filterType, maxLength }) => {
    let isClosed = false;
    let fValue = "";
    if (element && element.metadata && element.metadata.fields && element.metadata.fields[el.field]) {
        fValue = element.metadata.fields[el.field];
    }
    if (el[`${viewMode}extra`]) {
        return parseExtraField({ fieldValue: fValue, extra: el[`${viewMode}extra`] });
    }

    if (isGroup && el[`${viewMode}group`].isClosed) {
        if (element && element.metadata && (element.metadata.fields[el.field]
            || element.metadata.fields[el[`${viewMode}group`].with])) {
            isClosed = true;
        }
    }
    if (isGroup && el[`${viewMode}group`].dategroup) {
        return showDateGroup({
            isGroup, el, element, viewMode, txtClass,
            dategroup: el[`${viewMode}group`].dategroup
        });
    }

    if (el[`${viewMode}languagetype`]) {
        return showMappingLangType({ el, viewMode, fValue, txtClass });
    }

    if (el[`${viewMode}unittype`]) {
        return showMappingUnitType({ el, viewMode, fValue, txtClass });
    }

    let fieldTxt = parseStringField(fValue, filterType);
    fieldTxt = checkOtherConfig({ el, fieldTxt, viewMode });
    fieldTxt = checkMapping({ el, fieldTxt, term: ";" });
    if (el.optionAsMapp) return showOptionAsMapp({ fieldTxt, txtClass });
    return (
        <div className={txtClass}>
            {isClosed && <span>&laquo;</span>}
            {maxLength && fieldTxt ? sliceText(fieldTxt, maxLength) : fieldTxt}
            {checkGroupFields({ isGroup, el, element, viewMode })}
            {isClosed && <span>&raquo;</span>}
        </div>
    )
}

export const showLabelMetaGroup = ({ el, i, viewMode, element, labelClass, txtClass, boxClass, maxLength }) => {
    let labelField = el[`${viewMode}labelField`];
    if (!txtClass) txtClass = "col-lg-7 col-md-8 col-sm-8";
    if (element && element.metadata && element.metadata.fields[labelField]
        && element.metadata.fields[el.field]) {
        try {
            let labelArr = JSON.parse(element.metadata.fields[labelField]);
            let valueArr = JSON.parse(element.metadata.fields[el.field]);
            if (labelArr && labelArr.length && valueArr && valueArr.length) {
                return labelArr.map((entry, ie) => (
                    <ElementWrapper el={el} viewMode={viewMode} key={`${viewMode}detailLabelTxt${i}`}>
                        <div className={boxClass}>
                            <div className={labelClass}>
                                {labelArr[ie]}
                            </div>
                            <div className={txtClass}>
                                {maxLength && valueArr[ie] ? sliceText(valueArr[ie], maxLength) : valueArr[ie]}
                            </div>
                        </div>
                    </ElementWrapper>))
            }
        } catch (e) {
            console.log("LOGS: showLabelMetaGroup e", e);
        }
    }
}

export const showElementDate = ({ isGroup, el, element, viewMode, txtClass, labelClass, formatMessage, i, boxClass }) => {
    return (
        <ElementWrapper el={el} i={i} viewMode={viewMode} key={`${viewMode}meta${i}`}>
            <div className={boxClass}>
                <div className={labelClass}>
                    {formatMessage({ id: el.intl })}
                </div>
                {showDateGroup({ isGroup, el, element, viewMode, txtClass, dategroup: el[`${viewMode}group`].dategroup })}
            </div>
        </ElementWrapper>)
}

export const showElementMetaBox = ({
    el, i, isGroup = false, element, viewMode,
    formatMessage, labelClass, txtClass, boxClass, filterType, onHeadingClick, titleClass, maxLength, noLabelList }) => {
    if (!labelClass) labelClass = "col-lg-5 col-md-4 col-sm-4";
    if (!boxClass) boxClass = "row clipdetail-content-row";
    if (!txtClass) txtClass = "col-lg-7 col-md-8 col-sm-8";

    if (isGroup && el[`${viewMode}group`].isHeading) {
        return (
            <ElementWrapper el={el} i={i} viewMode={viewMode} key={`${viewMode}meta${i}`}>
                {/* <h1></h1> */}
                <h2 className={titleClass}
                    onClick={onHeadingClick && onHeadingClick}>
                    {parseStringField(element.metadata.fields[el.field], filterType)}
                    {checkGroupFields({ isGroup, el, element, viewMode })}
                </h2>
            </ElementWrapper>)
    }
    if (isGroup) {
        if (el[`${viewMode}group`].dategroup) {
            return showElementDate({ isGroup, el, element, viewMode, txtClass, labelClass, formatMessage, i, boxClass });
        }
        return (
            <ElementWrapper el={el} i={i} viewMode={viewMode} key={`${viewMode}meta${i}`}>
                <div className={boxClass}>
                    <div className={labelClass}>
                        {formatMessage({ id: el.intl })}
                    </div>
                    <div className={txtClass}>
                        {parseStringField(element.metadata.fields[el.field], filterType)}
                        {checkGroupFields({ isGroup, el, element, viewMode })}
                    </div>
                </div>
            </ElementWrapper>)
    }

    if (el[`${viewMode}labelField`]) {
        return showLabelMetaGroup({ el, i, viewMode, element, labelClass, txtClass, boxClass, maxLength })
    }
    return (
        <ElementWrapper el={el} viewMode={viewMode} key={`${viewMode}meta${i}`}>
            {/* <div className={boxClass} style={noLabelList ? { marginTop: "-20px" } : null}> */}
            <div className={boxClass}>
                {<div className={labelClass}>{formatMessage({ id: el.intl })}</div>}
                {getElementValue({ isGroup, el, element, viewMode, txtClass, filterType, maxLength })}
            </div>
        </ElementWrapper>
    )
}


